import { Box, Button, Flex, FormControl, Select } from '@chakra-ui/react'
import { InsuranceParamsDto, Offer, OfferVehicle } from 'BrokerTsLib/src/dtos'
import { useContext, useState } from 'react'
import ErrorSummary from '../../../../components/ErrorSummary'
import { FormLabel } from '../../../../components/FormLabel'
import { carkulkaOffersContext } from '../../../../context/CarkulkaOffersProvider'
import { useYearKm } from '../../../../hooks'
import { useSetOfferYearKm } from '../../../../hooks/useOffer'
import { Refresh } from '../../../../icons'
import { insuranceParamsContext } from '../../../../layouts/Wizard'
import { SaveAndRecalculateButton } from '../../../SaveAndRecalculateButton'
import { GetOfferElementId } from '../../OfferCar'

export const YearlyMilageTab = ({ offer, onSavedHandler }: { offer: OfferVehicle, onSavedHandler: Function }) => {
  const { recalculateOffers: recalculate } = useContext(carkulkaOffersContext)
  const { insuranceParamsId, insuranceParams } = useContext(insuranceParamsContext)
  const isContract = !!insuranceParams?.generalParams.contractNumber

  const [isSubmitting, setIsSubmitting] = useState(false)
  const { data } = useYearKm((insuranceParams as InsuranceParamsDto).vehicle.druh!)
  const { mutateAsync: updateYearKm } = useSetOfferYearKm()

  const [yearKm, setYearKm] = useState(offer.yearKm ?? (insuranceParams as InsuranceParamsDto).vehicle.yearKm);

  return (
    <Box>
      <FormControl>
        <FormLabel>Vyberte nájezd kilometrů za rok</FormLabel>

        <Flex sx={{ flexWrap: 'wrap', gap: 4, justifyContent: 'start' }}>

          {(data?.data.length ?? 0) > 0 &&
            <Select value={yearKm} onChange={(e) => setYearKm(e.target.value)} isDisabled={isContract}>
              <option disabled value=''>Vyberte roční nájezd</option>
              {data?.data.map((item) => (
                <option value={item.value?.toString() ?? ''} key={item.value}>{item.name}</option>
              ))}
            </Select>
          }

          {!isContract && <Button
            variant="outline"
            isDisabled={isSubmitting}
            isLoading={isSubmitting}
            loadingText="Přepočítávám..."
            onClick={() => {
              setIsSubmitting(true)
              updateYearKm({ offerId: offer.offerId, yearKm: yearKm })
                .then(() => {
                  onSavedHandler()
                  recalculate([offer.offerId], true)
                    .then(() => setTimeout(() => scrollToOffer(GetOfferElementId(offer.offerId)), 100))
                })
                .finally(() => {
                  setIsSubmitting(false)
                })
            }}
            gridColumnStart={1}>
            <Refresh color="secondary.500" />
            Uložit a přepočítat
          </Button>}

          {/* <ErrorSummary errors={errors} /> */}
        </Flex>
      </FormControl>
    </Box>
  )
}
function scrollToOffer(arg0: any): void {
  throw new Error('Function not implemented.')
}

